import cn from 'classnames';
import { MouseEvent } from 'react';

import styles from './CloseButton.module.scss';

interface ICloseButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
}

export const CloseButton = ({ className, ...rest }: ICloseButtonProps) => {
  const classNames = cn([className, styles.Close]);

  return (
    <button className={classNames} type="button" {...rest}>
      <span className={styles.Icon} />
    </button>
  );
};
